import {
  Component,
  Input,
  OnInit,
} from "@angular/core";
import * as moment from "moment-timezone";
import * as echarts from "echarts";

@Component({
  selector: "app-detailedgantt",
  templateUrl: "./detailedgantt.component.html",
  styleUrls: ["./detailedgantt.component.scss"],
})

export class DetailedganttComponent implements OnInit {
  @Input() gaugeArray: any;
  @Input() title: string = "";
  @Input() shiftData: any;
  @Input() timeZone: any;
  ganttChart: any = [];
  selectedDate: any;
  echartsInstance: any;
  res: any = [];
  breadCrumbItems: Array<{}>;
  option: any;

  constructor() { }
  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Charts" },
      { label: "E - Chart", active: true },
    ];
    if (this.gaugeArray.length) {
      if (this.title?.startsWith("Today")) {
        this.selectedDate = moment().format("YYYY-MM-DD");
      } else if (this.title?.startsWith("Yesterday")) {
        this.selectedDate = moment().subtract(1, "days").format("YYYY-MM-DD");
      } else if (this.title?.startsWith("Day Before Yesterday")) {
        this.selectedDate = moment().subtract(2, "days").format("YYYY-MM-DD");
      }
      if (this.shiftData.length > 1) {
        this.res = this.shiftData
          .slice(1)
          .map((item) => {
            let shiftStart = moment(
              `${this.selectedDate} ${item.startTime}`,
              "YYYY-MM-DD HH:mm:ss"
            );

            if (item.startNextDayFlag) {
              shiftStart.add(1, "day");
            }

            let shift_Start = shiftStart.format("YYYY-MM-DD HH:mm:ss");

            const shiftStartAdjusted = moment
              .tz(shift_Start, this.timeZone ? this.timeZone : "Asia/Kolkata")
              .valueOf();

            return [
              {
                xAxis: shiftStartAdjusted,
                label: {
                  show: true,
                  formatter: `${item.shiftName} - ${item.startTime}`,
                  position: "start",
                  distance: -10,
                },
                lineStyle: {
                  color: "#D84040",
                  width: 1,
                  type: "dotted",
                },
              },
            ];
          })
          .flat();
      } else {
        this.res = [];
      }
      this.ganttChart = this.gaugeArray;
      this.plotGanttchart();
    }
  }
  ngOnChanges(): void {
    if (this.gaugeArray.length) {
      if (this.title?.startsWith("Today")) {
        this.selectedDate = moment().format("YYYY-MM-DD");
      } else if (this.title?.startsWith("Yesterday")) {
        this.selectedDate = moment().subtract(1, "days").format("YYYY-MM-DD");
      } else if (this.title?.startsWith("Day Before Yesterday")) {
        this.selectedDate = moment().subtract(2, "days").format("YYYY-MM-DD");
      }
      if (this.shiftData.length > 1) {
        this.res = this.shiftData
          .slice(1)
          .map((item) => {
            let shiftStart = moment(
              `${this.selectedDate} ${item.startTime}`,
              "YYYY-MM-DD HH:mm:ss"
            );

            if (item.startNextDayFlag) {
              shiftStart.add(1, "day");
            }

            let shift_Start = shiftStart.format("YYYY-MM-DD HH:mm:ss");

            const shiftStartAdjusted = moment
              .tz(shift_Start, this.timeZone ? this.timeZone : "Asia/Kolkata")
              .valueOf();

            return [
              {
                xAxis: shiftStartAdjusted,
                label: {
                  show: true,
                  formatter: `${item.shiftName} - ${item.startTime}`,
                  position: "start",
                  distance: -10,
                },
                lineStyle: {
                  color: "#D84040",
                  width: 1,
                  type: "dotted",
                },
              },
            ];
          })
          .flat();
      } else {
        this.res = [];
      }
      this.ganttChart = this.gaugeArray;
      this.plotGanttchart();
    }
  }
  ngAfterViewInit(): void { }
  plotGanttchart() {
    var startTime = this.ganttChart[0]?.value[1];
    var lastDataTimestamp =
      this.ganttChart[this.ganttChart.length - 1]?.value[2];

    function formatTime(timestamp) {
      const date = new Date(timestamp);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return hours + ":" + minutes + ":" + seconds;
    }

    function renderItem(params, api) {
      var categoryIndex = api.value(0);
      var start = api.coord([api.value(1), categoryIndex]);
      var end = api.coord([api.value(2), categoryIndex]);
      var height = api.size([0, 1])[1] * 0.6;
      var rectShape = echarts.graphic.clipRectByRect(
        {
          x: start[0],
          y: start[1] - height / 2,
          width: end[0] - start[0],
          height: height,
        },
        {
          x: params.coordSys.x,
          y: params.coordSys.y,
          width: params.coordSys.width,
          height: params.coordSys.height,
        }
      );
      return (
        rectShape && {
          type: "rect",
          transition: ["shape"],
          shape: rectShape,
          style: api.style(),
        }
      );
    }

    this.option = {
      title: {
        text: this.title,
        left: "left",
        textStyle: {
          fontSize: 12,
        },
      },
      tooltip: {
        trigger: "item",
        backgroundColor: "rgba(0, 0, 0, 0.85)",
        borderColor: "#fff",
        borderWidth: 1,
        textStyle: {
          color: "#fff",
          fontSize: 14,
        },
        padding: 10,
        extraCssText:
          "border-radius: 8px; box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);",
        formatter: function (params) {
          var data = params.data;
          var statusColor =
            data.name === "Running"
              ? "#77ff5c"
              : data.name === "Idle"
                ? "#f9fc4d"
                : data.name === "Off"
                  ? "#b0b0b0"
                  : data.name === "Interlock"
                    ? "#7B542F"
                    : data.name === "Disconnect"
                      ? "#b0b0b0"
                      : data.name === "Breakdown"
                        ? "#eb5857"
                        : "grey";
          var reasonBlock = "";
          if (
            !(
              data.name === "Running" &&
              data.reasonData["reason"] === "Not Specified"
            )
          ) {
            reasonBlock = `
      <p style="margin: 5px 0;"><strong>Reason :</strong> ${data.reasonData["reason"]}</p>
      <p style="margin: 5px 0;"><strong>SubReason :</strong> ${data.reasonData["subReason"]}</p>
    `;
          }

          return `
            <div style="text-align: left; font-family: Arial, sans-serif; line-height: 1.5;">
              <p style="margin: 5px 0; font-size: 16px;">
              <strong>Status :</strong>
              <span style="color: ${statusColor}; font-weight: bold;">${data.name}</span>
              </p>
              <p style="margin: 5px 0;"><strong>From-To :</strong> ${data.fromTo}</p>
              <p style="margin: 5px 0;"><strong>Duration :</strong> ${data.value[3]}</p>
    ${data.part ? `<p style="margin: 5px 0;"><strong>Part :</strong> ${data.part}</p>` : ''}

              ${reasonBlock}
            </div>
            <div style="text-align: center;color: "white">(Click to View Status Chart)</div>
          `;
        },
      },
      // dataZoom: [
      //   {
      //     type: 'inside',
      //     filterMode: "weakFilter",
      //     start: 0,
      //     end: 100
      //   },
      //   {
      //     type: 'slider',
      //     filterMode: "weakFilter",
      //     start: 0,
      //     end: 100
      //   }
      // ],
      // xAxis: {
      //   min: startTime,
      //   max: lastDataTimestamp,
      //   scale: true,
      //   axisLabel: {
      //     lineStyle: {
      //       color: "#151515",
      //       width: 2,
      //     },
      //     formatter: function (val) {
      //       return moment(val).format("HH:mm:ss");
      //     },
      //   },
      //   splitLine: {
      //     show: false,
      //   },
      // },
      xAxis: {
        type: "time",
        min: startTime,
        max: lastDataTimestamp,
        scale: true,

        axisLabel: {
          formatter: (val) => {
            return moment(val).format("HH:mm:ss");
          }
        },

        interval: (lastDataTimestamp - startTime) / 4, // creates 4 sections = 5 labels (start + 3 + end)

        splitLine: {
          show: false,
        }
      },
      yAxis: {
        show: false,
        data: "1",
        axisLine: {
          lineStyle: {
            color: "#151515",
            width: 2,
          },
          show: true,
        },
      },
      grid: {
        left: "1%",
        right: "5%",
        top: "10%",
        bottom: "10%",
        containLabel: true,
        height: "80%",
      },
      series: [
        {
          type: "custom",
          renderItem: renderItem,
          itemStyle: {
            opacity: 0.8,
          },
          encode: {
            x: [1, 2],
            y: 0,
          },
          data: this.ganttChart,
          markLine: {
            tooltip: { show: false },
            symbol: "none",
            data: this.res,
          },
        },
      ],
    };
  }
  hms(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return (
      String(hours).padStart(2, "0") +
      ":" +
      String(minutes).padStart(2, "0") +
      ":" +
      String(remainingSeconds).padStart(2, "0")
    );
  }
}
